module.exports = __webpack_public_path__ + "media/img/Landing_Page/Scholarships2u-Apply-Scholarship-04c8679a24a00ee13f3e61c48e6d3640.svg";